/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CentStream } from '../../models/cent-stream';

export interface DownloadLink$Params {
  provider: 'SVG' | 'ASI';
  id: number;
}

export function downloadLink(http: HttpClient, rootUrl: string, params: DownloadLink$Params, context?: HttpContext): Observable<StrictHttpResponse<CentStream>> {
  const rb = new RequestBuilder(rootUrl, downloadLink.PATH, 'get');
  if (params) {
    rb.path('provider', params.provider, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CentStream>;
    })
  );
}

downloadLink.PATH = '/report/{provider}/{id}/download';
